export type LinkCallback = (paths: { path: string[], oldPath: string[] }) => void;

const directories: Record<string, { open?: LinkCallback, close?: LinkCallback }> = {}
let currentPath: string[] = [];

export function registerLinkDirectory(id: string, openCallback?: LinkCallback, closeCallback?: LinkCallback) {
    directories[id] = {
        open: openCallback,
        close: closeCallback
    };

    if (id === currentPath[0]) {
        try {
            openCallback?.({ path: currentPath, oldPath: [] });
        } catch {}
    }

    return () => delete directories[id];
}

export function openLink(link: string) {
    history.pushState("", document.title, location.pathname + "#" + link);
    onHashChange(null);
}

export function closeLink() {
    history.back();
}

export function getCurrentPath() {
    return currentPath;
}

// Svelte action
export function linkDirectory(node: Node, options: { id: string, openCallback?: LinkCallback, closeCallback?: LinkCallback }) {
    const destroy = registerLinkDirectory(options.id, options.openCallback, options.closeCallback);
    return { destroy }
}

function onHashChange(e: HashChangeEvent | null) {
    const oldPath = getPath(e?.oldURL) ?? currentPath;
    const path = getPath(location.hash);

    try {
        directories[oldPath[0]]?.close?.({ path, oldPath });
    } catch {}

    try {
        directories[path[0]]?.open?.({ path, oldPath });
    } catch {}
    currentPath = path;
}

function getPath(url: string | undefined) {
    return url?.split("#")[1]?.split("/") ?? [];
}

if (getPath(location.hash).length > 0) {
    const url = location.pathname + location.hash;
    history.replaceState(null, document.title, location.pathname);
    history.pushState("", document.title, url);
}

onHashChange(null);
window.addEventListener("hashchange", onHashChange);